import { useCallback, useState } from 'react';

type DialogToggle = {
  open: boolean;
  openDialog: () => void;
  closeDialog: () => void;
  setOpen: (value: boolean) => void;
};

export const useDialogToggle = (initial = false): DialogToggle => {
  const [open, setOpen] = useState(initial);
  const openDialog = useCallback(() => {
    setOpen(true);
  }, []);
  const closeDialog = useCallback(() => {
    setOpen(false);
  }, []);

  return { open, openDialog, closeDialog, setOpen };
};
